const FETCH_STORY_ADS = 'studioStoryAd/FETCH_STORY_ADS';
const CREATE_STORY_AD = 'studioStoryAd/CREATE_STORY_AD';
const PATCH_STORY_AD = 'studioStoryAd/PATCH_STORY_AD';
const RESET = 'studioStoryAd/RESET';
const FETCH_STORY_AD_EVENT_CHECK = 'studioStoryAd/FETCH_STORY_AD_EVENT_CHECK';
const FETCH_EPISODES = 'studioStoryAd/FETCH_EPISODES';

const FETCH_STORY_AD_VOUCHERS = 'studioStoryAd/FETCH_STORY_AD_VOUCHERS';
const FETCH_STORY_AD_VOUCHER_RECOMMENDATION =
  'studioStoryAd/FETCH_STORY_AD_VOUCHER_RECOMMENDATION';

export default {
  FETCH_STORY_ADS,
  CREATE_STORY_AD,
  PATCH_STORY_AD,
  RESET,
  FETCH_STORY_AD_EVENT_CHECK,
  FETCH_EPISODES,
  FETCH_STORY_AD_VOUCHERS,
  FETCH_STORY_AD_VOUCHER_RECOMMENDATION,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyAd/types.js